import { History } from "history";
import React from "react";
import { createRoot } from "react-dom/client";
import Redbox from "redbox-react";
import Root from "./root";
import { getEnv } from "./utils/environment";
import moment from "moment";

type ReactDomRoot = ReturnType<typeof createRoot>;

const roots = new WeakMap<Element, ReactDomRoot>();

function ensureRoot(element: HTMLElement): ReactDomRoot {
    let root = roots.get(element);
    if (!root) {
        root = createRoot(element);
        roots.set(element, root);
    }
    return root;
}
/**
 * Set application locale
 */
export function setLocale(locale: string): void {
    moment.locale(locale);
}

/**
 * Render application
 */
export async function render(
    element: HTMLElement | null,
    history: History,
    store: any
): Promise<void> {
    if (!element) {
        return;
    }

    const root = ensureRoot(element);
    try {
        root.render(<Root history={history} store={store} />);
    } catch (e) {
        const error = e instanceof Error ? e : new Error(String(e));
        if (getEnv().NODE_ENV !== "production") {
            root.render(<Redbox error={error} />);
        } else {
            root.render(<h1>Error: {error.message}</h1>);
        }
    }
}

/**
 * Render error
 */
export async function renderError(
    element: HTMLElement | null,
    e: Error
): Promise<void> {
    if (!element) {
        return;
    }
    const root = ensureRoot(element);
    root.render(<h1>Error at initialization: {e.message}</h1>);
}
